import { createStorageSlot } from '@gonfalon/browser-storage/createStorageSlot';

import { TREND_EXPLORER_STORAGE_KEY } from './constants';

/**
 * Clears AI Monitoring related storage when project changes occur.
 * This ensures that AI Monitoring preferences don't persist across different projects.
 */
export function clearAiMonitoringStorage() {
  // Use createStorageSlot for non-React contexts (as documented in browser-storage README)
  const storageSlot = createStorageSlot(TREND_EXPLORER_STORAGE_KEY, {
    storageType: 'localStorage',
  });
  storageSlot.remove();
}
